export const ADMIN_EMAILS = ["macceez@gmail.com", "elliadelgado@gmail.com"];
